export const loadFbSdk = () => {
  const script = document.createElement("script");
  script.src = "https://connect.facebook.net/en_US/sdk.js";
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
};

export const loadingMessageToText = (message: string) => {
  if (!message) {
    return null;
  }

  const prefix = `[META]`;
  if (message.includes("CREATING_KYD_AUDIENCE")) {
    return `${prefix} Creating KYD audience`;
  }

  if (message.includes("CREATING_CUSTOM_AUDIENCE")) {
    return `${prefix} Creating custom audience`;
  }

  if (message.includes("PUBLISHING_ADSET")) {
    return `${prefix} Publishing adset`;
  }

  if (message.includes("CREATING_CAMPAIGN")) {
    return `${prefix} Creating campaign`;
  }

  if (message.includes("PUBLISHING_CAMPAIGN")) {
    return `${prefix} Publishing campaign`;
  }

  if (message.includes("UPDATING_CAMPAIGN")) {
    return `${prefix} Updating campaign`;
  }

  if (message.includes("UPDATING_ADSET")) {
    return `${prefix} Updating adset`;
  }

  if (message.includes("CREATING_ADSET")) {
    return `${prefix} Creating adset`;
  }

  if (message.includes("CREATING_AD_CREATIVE")) {
    return `${prefix} Creating ad creative`;
  }

  if (message.includes("UPDATING_AD")) {
    return `${prefix} Updating ad`;
  }

  if (message.includes("CREATING_AD")) {
    return `${prefix} Creating ad`;
  }

  if (message.includes("CREATING_PAGE_LOOKALIKE_AUDIENCE")) {
    return `${prefix} Creating audiences`;
  }

  if (message.includes("POPULATING_AUDIENCE")) {
    return `${prefix} Populating audience`;
  }

  return message;
};
